import React from 'react';

const OrganizationJsonLd: React.FC = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "GreenTick AI",
    "alternateName": "GreenTick Research Lab",
    "url": "https://greentick.org.in",
    "logo": "https://greentick.org.in/logo.png",
    "sameAs": [
      "https://www.linkedin.com/company/hirewithgreentick",
      "https://twitter.com/greentick_ai",
      "https://github.com/greentick-ai"
    ],
    "description": "The world's first Human Potential Capture ecosystem for hiring assessments. We help companies hire the right person in 48 hours through verifiable behavioral intent and reasoning mapping.",
    "foundingDate": "2023",
    "areaServed": "Global",
    "knowsAbout": [
      "Human Potential Capture",
      "Behavioral Science",
      "Hiring Assessments",
      "Candidate Evaluation",
      "Reasoning Mapping"
    ]
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

export default OrganizationJsonLd;
